import { render, staticRenderFns } from "./JingquKoubeiDetail.vue?vue&type=template&id=084b22ac&scoped=true&"
import script from "./JingquKoubeiDetail.vue?vue&type=script&lang=js&"
export * from "./JingquKoubeiDetail.vue?vue&type=script&lang=js&"
import style0 from "./JingquKoubeiDetail.vue?vue&type=style&index=0&id=084b22ac&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084b22ac",
  null
  
)

export default component.exports